module.exports = __webpack_public_path__ + "static/media/addproject.af1e6513.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Icons/addproject.png
// module id = 1129
// module chunks = 0